var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstAidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.086,
    height: 16.352,
    viewBox: "0 0 19.086 16.352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-briefcase-medical",
    "data-name": "Icon awesome-briefcase-medical",
    d: "M17.3,5.52H14.315V3.885A1.718,1.718,0,0,0,12.525,2.25H6.561A1.718,1.718,0,0,0,4.772,3.885V5.52H1.789A1.718,1.718,0,0,0,0,7.156v9.811A1.718,1.718,0,0,0,1.789,18.6H17.3a1.718,1.718,0,0,0,1.789-1.635V7.156A1.718,1.718,0,0,0,17.3,5.52ZM7.157,4.43h4.772V5.52H7.157Zm5.964,8.449a.287.287,0,0,1-.3.273H10.736v1.908a.287.287,0,0,1-.3.273H8.648a.287.287,0,0,1-.3-.273V13.151H6.263a.287.287,0,0,1-.3-.273V11.244a.287.287,0,0,1,.3-.273H8.35V9.063a.287.287,0,0,1,.3-.273h1.789a.287.287,0,0,1,.3.273v1.908h2.088a.287.287,0,0,1,.3.273Z",
    transform: "translate(0 -2.25)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstAidIcon);
export default __webpack_public_path__ + "static/media/first-aid-icon.521f3eb001e0558e8d773f447840ba1a.svg";
export { ForwardRef as ReactComponent };